import React, { useState } from "react";
import Grid from "@mui/material/Grid2";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Box, FormControl, FormHelperText, Typography } from "@mui/material";
import MaterialInput from "../../../../components/MaterialInput";
import MaterialButton from "../../../../components/MaterialButton";
import SiderBorder from "../../../components/SiderBorder";
import PasswordBox from "../../../components/PasswordBox";
import BackLogin from "../../../components/BackLogin";
import request from "graphql-request";
import BASEURL from "../../../../pages/Utils/Baseurl";
import { passwordResetMail } from "./forgotData";
import { useLoading } from "../../../../context/LodingContext";
import PageLayout from "../../../../layoutcontainers/PageLayout";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

const EmailForgotInput = () => {
  const [forgotState, setForgotState] = useState({
    email: "",
    emailStatus: "",
  });
  const { setCirleLoading } = useLoading();
  const navigate = useNavigate();

  const handleChange = (e) => {
    const value = e?.target.value;

    const alphaNLenghthRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (alphaNLenghthRegex.test(value)) {
      setForgotState({
        email: value,
        emailStatus: "success",
      });
    } else if (!value) {
      setForgotState({
        email: "",
        emailStatus: "unchecked",
      });
    } else {
      setForgotState({
        email: value,
        emailStatus: "error",
      });
    }
  };

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      forgotState.emailStatus === "success" 
    
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const handleSumbit = async () => {
    setCirleLoading(true);
    try {
      const res = await request(BASEURL, passwordResetMail, {
        email: forgotState?.email,
      });

      const status = await res?.passwordResetMail?.success;
      const message = await res?.passwordResetMail?.message;

      if (status) {
        Swal.fire({
          position: "top",
          icon: "success",
          title: message,
          showConfirmButton: true,
          didOpen: () => {
            document.querySelector(".swal2-popup").style.zIndex =
              "99999999999999";
          },
        }).then(() => {
          navigate("/sign-in");
        });
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
          didOpen: () => {
            document.querySelector(".swal2-popup").style.zIndex =
              "999999999999999";
          },
        });
      }
    } catch (err) {
    } finally {
      setCirleLoading(false);
    }
  };
  
  const keydownHandler = (event) => {
    if (event.key == "Enter" &&   forgotState.emailStatus === "success" ) {
      handleSumbit();
    }
  };
  return (
    <PageLayout disableFooter showNavbar>
      <PasswordBox>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Box
            sx={{ display: "flex", alignItems: "center", margin: "10px 0px" }}
          >
            <SiderBorder />{" "}
            <Typography sx={{ color: "#2a9941", display: "inline-block" }}>
              Forgot Mail
            </Typography>{" "}
            <SiderBorder />
          </Box>
        </Box>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, sm: 12 }}>
            <MaterialInput
              fullWidth
              onKeyDown={keydownHandler}
              placeholder="Email"
              name="email"
              variant="outlined"
              value={forgotState.email}
              onChange={handleChange}
              error={forgotState.emailStatus === "error" ? true : false}
              success={forgotState.emailStatus === "success" ? true : false}
            />
            {forgotState.emailStatus === "error" && (
              <FormControl error>
                <FormHelperText>Invalid email </FormHelperText>
              </FormControl>
            )}
          </Grid>
        </Grid>
        <Box sx={{ display: "flex", justifyContent: "end" }}>
          <BackLogin />
        </Box>
        <Box sx={{ padding: "7px 0px", width: "100%" }}>
          <MaterialButton
            onClick={handleSumbit}
                disabled={!checkAllFields()}
            variant="contained"
            color="primary"
            fullWidth
          >
            Submit
          </MaterialButton>
        </Box>
      </PasswordBox>
    </PageLayout>
  );
};

export default EmailForgotInput;
